/**
 * Created by Bob.Bao on 2018/1/2.
 */
import apis from '@/store/apis'

const rules = {
    idCard: [
        { required: true, message: '请输入身份证', trigger: 'blur' },
        {validator: validateIdCard, trigger: 'blur'}
    ],
    fnameL2: [
        { required: true, message: '请输入供应商单位名称', trigger: 'blur' },
        { min: 2, message: '至少 2 个字符', trigger: 'blur' },
        { validator: 'regexp', pattern: /^[\u4E00-\u9FA50-9A-Za-z（）()、]+$/, message: '供应商名称只允许中英文（可包含括号、数字）', trigger: 'blur'},
        { validator: checkCompanyName, trigger: 'blur' }
    ],
    fcallname: [
        { required: true, message: '请输入姓名', trigger: 'blur' },
        { min: 2, message: '至少 2 个字符', trigger: 'blur' }
    ],
    floginnum: [
        { required: true, message: '请输入登录名称', trigger: 'blur' },
        { min: 3, message: '至少 3 个字符', trigger: 'blur' }
    ],
    fpassword: [
        { required: true, message: '请输入登录密码', trigger: 'blur' },
        { min: 6, message: '至少 6 位密码', trigger: 'blur' }
    ],
    smsCode: [{ required: true, message: '请输入验证码' }],
    // responser
    personInChange: [{ required: true, message: '请输入公司负责人', trigger: 'blur' }],
    personInChangeNo: [
        { required: true, message: '请输入公司负责人身份证', trigger: 'blur' },
        { validator: validateIdCard, trigger: 'change,blur' }
    ],
    fsuppliertypeid: [
        { required: true, message: '请选择公司类型', trigger: 'change' }
    ],
    fbuilddate: [
        { required: true, message: '请选择成立日期', trigger: 'change' }
    ],
    fenterprisemaster: [
        { required: true, message: '请输入法人代表', trigger: 'blur' }
    ],
    fenterprisemasterid: [
        { required: false, message: '请输入法人代表身份证', trigger: 'blur' },
        { validator: validateIdCard, trigger: 'blur' }
    ],
    fcityid: [
        { required: false, message: '请选择城市', trigger: 'change' }
    ],
    fprovinceid: [
        { required: true, message: '请选择省份', trigger: 'change' }
    ],
    cfcompanyaddres: [
        { required: true, message: '请输入公司注册地址', trigger: 'blur' }
    ],
    faddress: [
        { required: true, message: '请输入公司办公地址', trigger: 'blur' }
    ],
    flinkphone: [

    ],
    fpostnumber: [

    ],
    ftaxpayertype: [
        { required: true, message: '请选择纳税人身份', trigger: 'change' }
    ],
    fregistermoney: [
        {required: true, message: '请输入注册资金', trigger: 'blur'},
        { validator: 'regexp', pattern: /^(\d+(\.\d+)?)?$/, message: '注册资金必须为数字值', trigger: 'change'}
    ],
    fenterprisekind: [],
    fdescriptionL2: [],
    flastfyearprj: [],
    fpersonname: [
        { required: true, message: '请输入联系人姓名', trigger: 'blur' },
        { pattern:  /^(?!.*[\s])/g,message:'请勿输入空格、回车等非法字符',trigger:'blur'}
    ],
    personType: [{ required: true, message: '请选择', trigger: 'blur' }],
    fphone: [
        { required: true, message: '手机号不能为空' },
        { validator: 'regexp', pattern: /^1\d{10}$/, message: '手机号码不正确', trigger: 'blur' }
    ],
    femail: [
        { required: true, message: '电子邮箱不能为空' },
        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
    ],
    cfprovinceid: [{ required: true, message: '请选择省份', trigger: 'blur change' }],
    cfcityid: [{ required: false, message: '请选择城市', trigger: 'blur change' }],
    cfcellpeopleid: [{ required: true, message: '请选择专业负责人', trigger: 'blur change' }],
    cfservicetypeid: [{ required: true, message: '请选择产品与服务', trigger: 'blur change' }],
    provinceArr: [{ required: true, message: '请选择服务区域', trigger: 'blur change' }],
    name: [
        { required: true, message: '请输入项目经理姓名', trigger: 'blur' },
        { pattern:  /^(?!.*[\s])/g,message:'请勿输入空格、回车等非法字符',trigger:'blur'}
    ],
    mobile: [
        { required: true, message: '手机号不能为空' },
        { validator: 'regexp', pattern: /^1\d{10}$/, message: '手机号码不正确', trigger: 'blur' }
    ],
    officeTel: [],
    email: [
        { required: true, message: '电子邮箱不能为空' },
        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
    ],
    faptname: [
        { required: true, message: '文件名称不能为空' }
    ],
    typeName: [
        { required: true, message: '资质名称及等级不能为空' }
    ],
    fyear: [
        { required: true, message: '年份不能为空' },
        { validator: 'regexp', pattern: /^20\d{2}$/, message: '不是有效年份', trigger: 'blur' }
    ],
    fsalecount: [
        { required: true, message: '销售额不能为空' },
        { type: 'number', message: '必须为数字', trigger: 'blur' }
    ],
    fprojectname: [
        { required: true, message: '请输入工程名称', trigger: 'blur' },
        { pattern:  /^(?!.*[\s])/g,message:'请勿输入空格、回车等非法字符',trigger:'blur'}
    ],
    fclientname: [
        { required: true, message: '请输入客户名称', trigger: 'blur' }
    ],
    fclientaddress: [
        { required: true, message: '请输入工程地址', trigger: 'blur' }
    ],
    fclientlinkperson: [
        { pattern:  /^(?!.*[\s])/g,message:'请勿输入空格、回车等非法字符',trigger:'blur'}
    ],
    fcontractpay: [
        { required: true, message: '合同金额不能为空', trigger: 'blur' }
    ],
    fstartdate: [
        { required: true, message: '开始日期不能为空' }
    ],
    fenddate: [
        { required: true, message: '结束日期不能为空' }
    ],
    fremark: '', //备注
    baseFiles: [
        { required: true, message: '附件不能为空' }
    ],
    gysfj: [
        { required: true, message: '文件不能为空' }
    ],
    faptnumber: [{ required: true, message: '文件标号不能为空' }],
    fawardunit: [{ required: true, message: '颁发单位不能为空' }],
    address: [

    ],
    bankNo: [
        { required: true, message: '银行账号必填', trigger: 'blur' }
    ],
    baseFileList: [
        { required: true, message: '需提供6个月社保缴纳记录证明'}
    ]
}

function checkCompanyName(rule, value, callback) { //检查供应商名称
    if(value.indexOf("已清算")!=-1||value.indexOf("封存")!=-1){
        callback(new Error("供应商不应包含已清算或封存内容"))
    }else{
        apis.checkCompanyName(value).then((res) => {
            if (res.data.result) {
                callback()
            } else {
                callback(new Error(res.data.message))
            }
        }, e => {
            alert(e)
            callback()
        })
    }

}

function validateIdCard(rule, code, callback) {
    const city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
    let tip = '',
        pass = true;
    if (!code) {
        pass = true
    } else if (!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = "身份证号格式错误";
        pass = false;
    } else if (!city[code.substr(0, 2)]) {
        tip = "地址编码错误";
        pass = false;
    } else {
        if (code.length == 18) {
            code = code.toUpperCase().split('');
            const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
            let sum = 0;
            let ai = 0;
            let wi = 0;
            for (let i = 0; i < 17; i++) {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
            }
            let last = parity[sum % 11];
            if (parity[sum % 11] != code[17]) {
                tip = "校验位错误";
                pass = false;
            }
        }
    }
    if (pass) {
        callback()
    } else {
        callback(new Error(tip))
    }
}

let accountRules = {}
__rules_generator(accountRules, ['fnameL2', 'fcallname', 'fpassword', 'smsCode', 'femail'], rules)
let companyRules = {}
__rules_generator(companyRules, ['fcallname', 'personInChangeNo', 'fsuppliertypeid', 'fbuilddate', 'fenterprisemaster', 'fcityid', 'fprovinceid', 'idCard',
    'cfcompanyaddres', 'faddress', 'flinkphone', 'fpostnumber', 'ftaxpayertype', 'fregistermoney', 'femail'
], rules)
let basicRules = {}
__rules_generator(basicRules, ['fsuppliertypeid', 'fbuilddate', 'fenterprisemaster', 'fenterprisemasterid', 'fcityid', 'fprovinceid',
    'cfcompanyaddres', 'faddress', 'flinkphone', 'fpostnumber', 'ftaxpayertype'
], rules)
let otherRules = {}
__rules_generator(otherRules, ['fregistermoney', 'fenterprisekind', 'fdescriptionL2', 'flastfyearprj'], rules)
let contactRules = {}
__rules_generator(contactRules, ['fpersonname', 'personType', 'fphone', 'femail', 'idCard'], rules)
let areaRules = {}
__rules_generator(areaRules, ['cfprovinceid', 'cfcityid'], rules)
let spssRules = {}
__rules_generator(spssRules, ['cfcellpeopleid', 'cfservicetypeid', 'provinceArr'], rules)
let managerRules = {}
__rules_generator(managerRules, ['name', 'mobile', 'email', 'idCard', 'baseFileList'], rules)
let salesRules = {}
__rules_generator(salesRules, ['fyear', 'fsalecount'], rules)
let achievementRules = {}
__rules_generator(achievementRules, ['fprojectname', 'fclientname', 'fclientaddress', 'fclientlinkperson',
    'fphone', 'fcontractpay', 'fstartdate', 'fenddate', 'baseFiles'
], rules)
let aptitudeRules = {}
__rules_generator(aptitudeRules, ['faptname', 'typeName', 'fstartdate', 'fenddate', 'baseFiles'], rules)
let gysfjRules = {}
__rules_generator(gysfjRules, ['baseFiles'], rules)
let rulesBank = {
    address: [
        {required: true, message: '银行所在市必须填写',trigger:'blur'},
        { validator: 'regexp', pattern: /^[\u4E00-\u9FA5]+市|州[\u4E00-\u9FA5]*$/, message: '请输入中文,须含有\'市\'或\'州\'', trigger: 'blur'},
    ],
    accountName: [
        {required: true, message: '银行开户名必须填写'},
        { validator: 'regexp', pattern: /^[\u4E00-\u9FA5A-Za-z0-9（）()-、]+$/, message: '只允许输入中文、英文、数字、括号、-', trigger: 'blur'}
    ],
    name: [
        {required: true, message: '开户行全称必须填写'},
        { validator: 'regexp', pattern: /^[\u4E00-\u9FA5A-Za-z]+支行|分行|信用社|分理处|分社|营业部|营业所|村镇银行|信用合作社|联合社|金库|国库|支库|银行|信用合作联社[\u4E00-\u9FA5A-Za-z]*$/, message: '仅允许中英文,且必须包含支行,分行,信用社,分理处,分社,营业部,营业所,村镇银行,信用合作社,联合社,金库,国库,支库,银行,信用合作联社等关键字之一', trigger: 'blur'},
        { pattern:  /^(?!.*[\s])/g,message:'请勿输入空格、回车等非法字符',trigger:'blur'}
    ],
    relationNo: [
        {required: true, message: '银行关联行号必须填写'},
        { validator: 'regexp', pattern: /^[\dA-Za-z]+$/, message: '银行关联行号必须为数字或字母', trigger: 'blur'}
    ],
    bankNo: [
        {required: true, message: '银行账号必须填写'},
        { validator: 'regexp', pattern: /^[A-Za-z\d-]+$/, message: '银行账号必须为数字（可包含英文和-）', trigger: 'blur'}
    ]
}

export {
    accountRules,
    companyRules,
    basicRules,
    otherRules,
    contactRules,
    areaRules,
    spssRules,
    managerRules,
    salesRules,
    achievementRules,
    aptitudeRules,
    gysfjRules,
    rulesBank
}

function __rules_generator(obj, keys, rules) {
    keys.forEach(k => {
        return obj[k] = rules[k]
    })
}



// WEBPACK FOOTER //
// ./src/util/rules.js